<template>
    <div class="pm-box">
        <el-form :inline="true" :model="formInline" class="demo-form-inline">
            <el-form-item label="项目标题">
                <el-input size="medium" v-model="formInline.title" placeholder="请输入项目标题"></el-input>
            </el-form-item>
            <el-form-item>
                <el-button size="medium" type="primary" @click="onSubmit(2)">查询</el-button>
            </el-form-item>
        </el-form>
        <el-table :data="tableData" style="width: 100%">
            <el-table-column prop="title" label="项目标题" style="color: aqua;">
                <template slot-scope="scope">
                    <div class="link-text" @click="jumpDetail(scope.row)">{{ scope.row.title }}</div>
                </template>
            </el-table-column>

            <el-table-column prop="company_name" label="中标单位"></el-table-column>
            <el-table-column prop="bid_price" label="中标金额"></el-table-column>
            <el-table-column prop="bid_type_name" label="采购类型"></el-table-column>
            <el-table-column prop="bulletin_title" label="结果公告"></el-table-column>
            <el-table-column prop="update_time" label="发布时间"></el-table-column>
            <el-table-column prop="join_time" label="公告截止时间"></el-table-column>
        </el-table>

        <!-- 项目详情 -->
        <el-dialog :title="detailsData.title" width="60%" :visible.sync="detailsShow">
            <div>
                <el-form ref="form" :model="detailsData" style="display: flex;flex-wrap: wrap;">
                    <el-form-item style="width: 100%;">
                        <p v-html="detailsData.bulletin_desc" style="padding: 0 15px;"></p>
                    </el-form-item>
                    <el-form-item label="公告附件:" style="width: 100%;">
                        <div style="width: 300px;">
                            <p class="down-tetx" v-for="(item, index) in detailsData.bulletin_url" :key="index"
                                @click="downFile(item.url)">
                                {{ item.name }}
                            </p>
                        </div>

                    </el-form-item>

                </el-form>
                <el-button type="primary" @click="handleApplyShow" v-show="detailsData.is_baoming === 0">报名</el-button>

            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="detailsShow = false" type="info">关闭</el-button>
            </span>
        </el-dialog>


    </div>
</template>

<script>
import { noticePage } from '@/api/index.js'
export default {
    name: "resultNotice",
    data() {
        return {
            id: '',
            activeName: '3',
            tableData: [],
            tableData2: [],
            tableData3: [],
            formInline: {},
            detailsShow: false,
            zbDetailsShow: false,
            applyShow: false,
            applyForm: {},
            detailsData: {},
            nowIntro: '',
            btnLoading: false,
            rules: {
                name: [{ required: true, message: '请输入联系人名称', trigger: 'change' }],
                mobile: [{ required: true, message: '请输入联系人电话', trigger: 'change' }],
                address: [{ required: true, message: '请输入联系地址', trigger: 'change' }],
            }
        }
    },
    watch: {
        activeName() {
            this.getNoticePage(3)
            this.formInline.title = ''
        }
    },
    mounted() {
        this.$nextTick(() => {
            this.getNoticePage(3)
        })
    },
    methods: {
        seeDetails(intro) {
            this.nowIntro = intro
            this.zbDetailsShow = true
        },
        downFile(file) {
            window.open(file)
        },
        jumpDetail(item) {
            console.log(item)
            this.detailsData = item
            this.detailsShow = true

        },
        handleApplyShow() {
            this.applyForm = {}
            this.applyShow = true
            if (this.$refs['applyForm']) {
                this.$refs['applyForm'].clearValidate()
            }
            console.log(this.applyShow)
        },
        applySubmit() {
            let params = this.applyForm;
            params.id = this.detailsData.id;
            this.$refs['applyForm'].validate((valid) => {
                if (valid) {
                    apply(params).then(res => {
                        console.log(res)
                        if (res.data.code === 1) {
                            this.$message.success('报名成功')
                        } else {
                            this.$message.warning(res.data.msg)
                        }
                        this.btnLoading = false
                        this.applyShow = false
                    }).catch(err => {
                        console.log(err)
                        this.btnLoading = false
                        this.$message.error('请求失败')

                    })
                }
            });


        },
        getNoticePage(type) {
            let params = {}
            params.type = type
            params.title = this.formInline.title
            noticePage(params).then(res => {
                console.log(type)
                console.log(res)
                let dataList = res.data.data.list ? res.data.data.list : []
                this.tableData = dataList
            }).catch(err => {
                this.$message.error(err.data.msg)
            })
        },
        initial(e) {
            api1({ type_id: e }).then(res => {
                if (res.data.code === 1) {
                    if (e === 1) {
                        this.tableData1 = res.data.data.lists
                    } else {
                        this.tableData3 = res.data.data.lists
                    }
                } else {
                    this.$message.error(res.data.msg)
                }
            })
        },
        onSubmit() {

        }
    }

}
</script>

<style scoped>
>>>.el-dialog__header {
    text-align: center;
}

>>>.el-dialog__body {
    max-height: 500px;
    overflow: scroll;
}

.tishi {
    font-weight: 400;
    font-size: 14px;
    color: #E90000;
    margin-top: 20px;
}

.pm-box {
    width: 100%;
    height: 100%;
    padding: 0px;
    box-sizing: border-box;
    background: #fff;
}

.link-text {
    cursor: pointer;
    color: #09f;
}

.down-tetx {
    cursor: pointer;
    color: #09f;
    width: 300px;
    overflow: hidden;
}

.demo-form-inline {
    display: flex;
    justify-content: flex-start;
}
</style>


// WEBPACK FOOTER //
// src/components/ResultNotice.vue